import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { PincodeActionTypes, PincodeActions } from "../../../actionTypes/master/pincodeActionTypes";

import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { createPincodeApi, editPincodeByPincodeApi, getPincodeByPincodeApi, getPincodeListApi } from "../../requests/master/pincodeRequest";
import { getPincodeList, setPincodeDataByPincode, setPincodeList, setPincodeListPageCount } from "../../../actions/master/pincodeActions";


function* createPincodeHandler(action: PincodeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createPincodeApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getPincodeListHandler(action: PincodeActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getPincodeListApi, action.payload);

    if (data.status) {
      yield put(setPincodeList(data?.data?.rows));
      yield put(setPincodeListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getPincodeDataByIdHandler(action: PincodeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getPincodeByPincodeApi, action.payload);
    if (data.status) {
      yield put(setPincodeDataByPincode(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editPincodeDataByIdHandler(action: PincodeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editPincodeByPincodeApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getPincodeList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// pincode sagas

export default function* pincodeSaga() {
  yield takeLatest(PincodeActions.CREATE_PINCODE, createPincodeHandler);
  yield takeLatest(PincodeActions.GET_PINCODE_LIST, getPincodeListHandler);
  yield takeLatest(PincodeActions.GET_PINCODE_DATA_BY_PINCODE, getPincodeDataByIdHandler);
  yield takeLatest(PincodeActions.EDIT_PINCODE_DATA_BY_PINCODE, editPincodeDataByIdHandler);
}
